import { db, functions } from "@/services/config";
import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import type {
  PlansRecord,
  PaginatedHistory,
  PaymentHistoryItem,
  CreatePaymentRequest,
  ConfirmPaymentRequest,
} from "./plans.types";
import { httpsCallable } from "firebase/functions";

export class PlansService {
  /**
   * Busca todos os planos ativos ordenados pela prioridade
   */
  async getActivePlans(): Promise<PlansRecord[]> {
    try {
      const plansRef = collection(db, "plans");

      const q = query(
        plansRef,
        where("active", "==", true),
        orderBy("order", "asc"),
      );

      const querySnapshot = await getDocs(q);

      const plans = querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      })) as PlansRecord[];

      return plans;
    } catch (error) {
      console.error("Erro ao buscar planos:", error);
      throw error;
    }
  }

  /**
   * Busca o histórico de pagamentos do usuário logado
   */
  async getUserPlansHistory(
    pageSize: number = 15,
    lastId?: string,
  ): Promise<PaginatedHistory> {
    try {
      const getHistory = httpsCallable<
        { pageSize: number; lastId?: string },
        {
          success: boolean;
          history: PaymentHistoryItem[];
          lastVisibleId: string | null;
          hasMore: boolean;
        }
      >(functions, "getUserPlansHistory");

      const result = await getHistory({ pageSize, lastId });

      if (result.data.success) {
        return {
          history: result.data.history,
          lastVisibleId: result.data.lastVisibleId,
          hasMore: result.data.hasMore,
        };
      }

      return { history: [], lastVisibleId: null, hasMore: false };
    } catch (error) {
      console.error("Erro ao buscar histórico de planos no Service:", error);
      return { history: [], lastVisibleId: null, hasMore: false };
    }
  }

  async createPayment(data: CreatePaymentRequest) {
    const create = httpsCallable(functions, "createPaymentIntent");

    return create(data);
  }

  async confirmPayment(data: ConfirmPaymentRequest) {
    const confirm = httpsCallable(functions, "confirmPaymentIntent");

    return confirm(data);
  }
}

export const plansService = new PlansService();
